import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent, FormTextareaComponent } from '@shared/forms';
import { ModuleFacade } from '@app/store/module';
import { ModuleSelectionService } from '../module-selection.service';

@Component({
    selector: 'app-create-module',
    templateUrl: './create-module.component.html',
    styleUrls: ['./create-module.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, RouterLink, ButtonModule, FormInputComponent, FormTextareaComponent],
})
export class CreateModuleComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly moduleFacade = inject(ModuleFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly moduleSelectionService = inject(ModuleSelectionService);

    readonly saving = this.moduleFacade.saving;

    readonly form = this.formBuilder.group({
        name: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        description: this.formBuilder.control(''),
    });

    constructor() {
        effect(() => {
            const module = this.moduleFacade.module();
            if (this.moduleFacade.saved() && module) {
                this.moduleSelectionService.select({ id: module.id, name: module.name });
                this.close();
            }
        });

        effect(() => {
            if (this.moduleFacade.saving() === false && this.moduleFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.moduleFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            const value = this.form.getRawValue();
            this.moduleFacade.createModule({
                name: value.name,
                description: value.description || undefined,
            });
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { dialog: null } }]);
    }
}
